import React, { useEffect, useState } from "react";
import {
	Blacked,
	BoardViewInput,
	ModalContent,
	ModalHeader,
	ModalInput,
	ModalSubmit,
	ModalTitle,
	ModalWrapper,
} from "../styles";
import { Icon } from "CRM/organism/Main/styles";
import { FaChevronLeft } from "react-icons/fa6";
import { Input, Select, Upload, message } from "antd";
import { ChromePicker } from "react-color";
import API from "utils/api";
import { useToken } from "app/hooks";
import { usePathList } from "CRM/hooks/GetPathList";
import TextArea from "antd/es/input/TextArea";
import { useCategoryList } from "CRM/hooks/GetCategory";
import { usePlatformList } from "CRM/hooks/GetPlatformList";
import { useIsMobile } from "../IsMobile";
import { useNoticeInfo } from "../../hooks/GetNoticeInfo";
import { ImageModal } from "../Edit/ImageModal";
import { useFilterList } from "CRM/hooks/GetFilterList";

export const NoticeAdd = ({ setIsRequest, mutate, boardId, setBoardId }) => {
	const IsMobile = useIsMobile();
	const { noticeInfo } = useNoticeInfo(boardId);
	const { data: token } = useToken();
	const { categoryList } = useCategoryList();
	const { platformList } = usePlatformList();
	const { filterList: branchList } = useFilterList("branch");
	const [platform, setPlatform] = useState<number>(0);
	const [email, setEmail] = useState("");
	const [category, setCategory] = useState(categoryList?.[0]?.id);
	const [template, setTemplate] = useState("");
	const [title, setTitle] = useState("");

	const [images, setImages] = useState<any>([]);
	const [imagePath, setImagePath] = useState(null);

	useEffect(() => {
		// console.log('noticeInfo', noticeInfo);
		setTitle(noticeInfo?.title);
		setTemplate(noticeInfo?.content);
		setPlatform(noticeInfo?.branchName);
		setTitle(noticeInfo?.title);
	}, [noticeInfo]);

	const clickSubmit = () => {
		const shouldEdit = window.confirm(`내용을 등록하시겠습니까?`);
		if (shouldEdit) {
			const targetFilesArrayLogo = Array.from(
				images?.fileList || []
			);
			const formData = new FormData();

			if (images?.fileList?.length == 0) {
				message.error("파일을 선택해주세요");
				return;
			}

			targetFilesArrayLogo.forEach((file: any) => {
				if (file.originFileObj) {
					formData.append(
						"files",
						file.originFileObj
					);
				}
			});

			formData.append(
				"datas",
				JSON.stringify({
					title,
					content: template,
					target: platform,
				})
			);

			if (template == "") {
				message.error("내용을 입력해주세요.");
			}

			API.postImage(
				"POST",
				"/board/notice",
				token + "",
				formData
			)
				.then((res: any) => {
					if (res.result.success) {
						message.success(
							"등록되었습니다"
						);
						mutate();
						setIsRequest(false);
					} else {
						message.error(
							"파일이 잘못되었습니다"
						);
					}
				})
				.catch((err: any) => {});
		}
	};

	const clickEdit = () => {
		const shouldEdit = window.confirm(`내용을 수정하시겠습니까?`);
		if (shouldEdit) {
			const targetFilesArrayLogo = Array.from(
				images?.fileList || []
			);
			const formData = new FormData();

			if (images?.fileList?.length == 0) {
				message.error("파일을 선택해주세요");
				return;
			}

			targetFilesArrayLogo.forEach((file: any) => {
				if (file.originFileObj) {
					formData.append(
						"files",
						file.originFileObj
					);
				}
			});

			formData.append(
				"datas",
				JSON.stringify({
					title,
					content: template,
					target: platform,
				})
			);

			if (template == "") {
				message.error("내용을 입력해주세요.");
			}

			API.postImage(
				"PUT",
				`/board/notice/${boardId}`,
				token + "",
				formData
			)
				.then((res: any) => {
					if (res.result.success) {
						message.success(
							"수정되었습니다"
						);
						mutate();
						setIsRequest(false);
						setBoardId(null);
					} else {
						message.error(
							"파일이 잘못되었습니다"
						);
					}
				})
				.catch((err: any) => {});
		}
	};

	const handleKeyPress = (e) => {
		if (e.key === "Enter") {
			e.preventDefault();
			setTemplate((prevTemplate) => prevTemplate + "\n");
		}
	};

	return (
		<>
			<Blacked
				onClick={() => {
					setIsRequest(false);
					setBoardId(null);
				}}
			/>
			<ModalWrapper IsMobile={IsMobile}>
				<ModalHeader>
					<Icon
						onClick={() => {
							setIsRequest(false);
							setBoardId(null);
						}}
					>
						<FaChevronLeft />
					</Icon>
					<ModalTitle>공지사항</ModalTitle>
					<ModalSubmit
						onClick={
							boardId
								? clickEdit
								: clickSubmit
						}
					>
						{boardId ? "수정" : "등록"}
					</ModalSubmit>
				</ModalHeader>
				<ModalContent>
					<ModalInput>
						<label htmlFor="name">
							지사명
						</label>
						<Select
							value={
								platform == 0
									? "전체"
									: branchList?.find(
											(
												v
											) =>
												v.id ==
												platform
									  )
											?.name
							}
							onChange={(e) =>
								setPlatform(e)
							}
							placeholder="플랫폼 선택"
							style={{
								fontFamily: "Pretendard",
							}}
						>
							{[
								{
									id: 0,
									name: "전체",
								},
								{
									id: 1,
									name: "본사",
								},
								...(branchList ??
									[]),
							]
								.filter(
									(v) =>
										!(
											!process.env.REACT_APP_API_URL?.includes(
												"ccl"
											) &&
											v.id ==
												1
										)
								)
								.map((it) => (
									<option
										value={
											it.id
										}
										style={{
											fontFamily: "Pretendard",
										}}
									>
										{
											it.name
										}
									</option>
								))}
							{/* {["전체", "본사"].map((it) => (
								<option value={it} style={{ fontFamily: "Pretendard" }}>
									{it}
								</option>
							))} */}
						</Select>
					</ModalInput>
					<ModalInput>
						<label htmlFor="name">
							제목
						</label>
						<Input
							value={title}
							onChange={(e) =>
								setTitle(
									e.target
										.value
								)
							}
							placeholder="제목 입력"
						/>
					</ModalInput>
					{/*<ModalInput>*/}
					{/*	<label htmlFor="name">카테고리</label>*/}
					{/*	<Select*/}
					{/*		value={category}*/}
					{/*		onChange={e => setCategory(e)}*/}
					{/*		placeholder="카테고리 선택"*/}
					{/*		style={{ fontFamily: 'Pretendard' }}>*/}
					{/*		{categoryList?.map(it => (*/}
					{/*			<option value={it.id} style={{ fontFamily: 'Pretendard' }}>*/}
					{/*				{it.name}*/}
					{/*			</option>*/}
					{/*		))}*/}
					{/*	</Select>*/}
					{/*</ModalInput>*/}
					<ModalInput>
						<label htmlFor="desc">
							내용입력
						</label>
						<TextArea
							value={template}
							onKeyPress={
								handleKeyPress
							}
							onChange={(e) =>
								setTemplate(
									e.target
										.value
								)
							}
							placeholder="게시글을 작성하세요."
							style={{
								width: "100%",
								height: 200,
								resize: "none",
								fontFamily: "Pretendard",
							}}
						/>
					</ModalInput>

					{noticeInfo?.imageList && (
						<BoardViewInput
							style={{
								border: "1px solid #CFCFCF",
								borderRadius: 2,
							}}
						>
							<label
								style={{
									padding: "90px 10px",
								}}
							>
								이미지
							</label>
							<div
								style={{
									display: "flex",
									flexDirection:
										"column",
									gap: 5,
									cursor: "pointer",
								}}
							>
								{noticeInfo?.imageList?.map(
									(
										item,
										index
									) => (
										<div
											style={{
												cursor: "pointer",
											}}
											onClick={() => {
												setImagePath(
													item.image
												);
											}}
										>
											<img
												src={
													process
														.env
														.REACT_APP_API_URL +
													item.image
												}
												alt={`boardContent_Image${index}`}
												width={
													60
												}
												height={
													60
												}
											/>
										</div>
									)
								)}
							</div>
							{/*<p style={{ height: 200, overflowY: 'auto' }}>{boardContent?.content}</p>*/}
						</BoardViewInput>
					)}

					<ModalInput>
						<label htmlFor="desc">
							이미지 업로드
						</label>

						<Upload
							onChange={(
								fileList: any
							) => {
								setImages(
									fileList
								);
							}}
						>
							파일선택
						</Upload>
					</ModalInput>
				</ModalContent>
			</ModalWrapper>

			{imagePath !== null && (
				<ImageModal
					imagePath={imagePath}
					setImagePath={setImagePath}
				/>
			)}
		</>
	);
};

export default React.memo(NoticeAdd);
